import { IBalanceState } from './interfaces';

export const balanceSelectors = {
    getFormattedBalance: (state: IBalanceState) => state.formattedAmount,

    getIsUnavailable: (state: IBalanceState) => state.unavailable,
};
